export const TextCss ={
    top_header:"top_header",
    main_heading_700_20:"main_heading fw-700", //fontsize-20
    heading_700_16:"heading  fw-700",//fontsize-16
    heading_600_16:"heading  fw-600",//fontsize-16
    sub_heading_400_14:"sub_heading fw-400",
    sub_text_400_12:"sub_text",
    normal_text_400_14:"normal_text  fw-400",
    
    black:{
    top_header_700_24:"top_header black fw-700",
    main_heading_700_20:"main_heading black fw-700", //fontsize-20
    normal_text_700_14:"normal_text black fw-700",
    heading_700_16:"heading black fw-700",//fontsize-16
    heading_600_16:"heading black fw-600",//fontsize-16 
    sub_heading_600_14:"sub_heading black fw-600",
    normal_text_400_14:"normal_text black fw-400",
    sub_Heading_400_16:"sub_heading black fw-400",
    sub_text_400_12:"sub_text black fw-400"
    },
    grey_neutral:{
       top_header_700_24:"top_header grey_subtext1 fw-700",
       sub_heading_400_14:"sub_heading grey_subtext1 fw-400", 
       sub_Heading_400_16:"heading grey_subtext1 fw-400", 
       sub_heading_600_14:"sub_heading grey_subtext1 fw-600",
       sub_Heading_700_16:"heading grey_subtext1 fw-700", 
       heading_500_16:"heading grey_subtext1 fw-500",
    }
}